import { render, staticRenderFns } from "./ConfirmBeneficialOwner.vue?vue&type=template&id=c671f0e2&scoped=true&"
import script from "./ConfirmBeneficialOwner.vue?vue&type=script&lang=js&"
export * from "./ConfirmBeneficialOwner.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmBeneficialOwner.vue?vue&type=style&index=0&id=c671f0e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c671f0e2",
  null
  
)

export default component.exports